import PouchDB from 'pouchdb-browser';
import { Capacitor } from '@capacitor/core';
import { CapacitorSQLitePouch } from './adapter';

// Register the adapter on every Capacitor native platform, because every one of
// them now has a CsSQLitePlugin behind it: Swift on iOS, Java on Android.
//
// REGISTERING IS NOT SELECTING, and that distinction is the whole reason this
// is safe to widen ahead of the rest of the work. This call only tells PouchDB
// that a database MAY be opened with `adapter: 'capacitor-sqlite'`. What decides
// whether any database actually is opened that way is getLocalAdapterOpts in
// services/local-database-engine.ts, which asks the one engine question,
// `usesSqliteEngine()` (#4981 phase 2). Today that still answers yes only on iOS
// native and on a device phase 3 has migrated — of which there are none. So
// widening this line changed nothing a user can see; it just stops Android from
// having to register the adapter separately later.
// See design-docs/android-local-database-engine.md.
export function registerCapacitorSQLiteAdapter() {
  if (Capacitor.isNativePlatform()) {
    (CapacitorSQLitePouch as any).valid = () => true;
    (PouchDB as any).adapter('capacitor-sqlite', CapacitorSQLitePouch, false);
    console.log(`PouchDB: registered capacitor-sqlite adapter for ${Capacitor.getPlatform()}`);
  }
}
